import {
  Component,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
  ViewChild,
  ElementRef,
  Input,
  AfterViewInit
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {select, Store} from '@ngrx/store';
import { ParticleState } from '@shared/store/reducers/particle.reduer';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {OptionItem} from '@shared/models/option-item';
import {QueryProvider} from '@shared/queries/query-provider';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {skip, takeUntil} from 'rxjs/operators';
import {MatInput} from '@angular/material/input';

@Component({
    standalone: false,
    selector: 'particle-create-case-dialog',
  templateUrl: './create-case-dialog.component.html',
  styleUrls: ['./create-case-dialog.component.scss']
})
export class CreateCaseDialogComponent implements OnInit, IDialogView, OnDestroy, AfterViewInit {
  @ViewChild('title', {read : MatInput, static: true})elementRef: MatInput;

  data: DialogModel;
  form: FormGroup;
  inputForm: any;
  inputFormError: any;
  isCaseTypeDisabled: boolean;
  caseList$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  filedPeriodList$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  unsubscribe$ = new Subject<void>();
  private caseList: any;
  inputFormErrors: any;

  constructor (private formBuilder: FormBuilder,
               protected particleStore: Store<ParticleState>,
               protected queryStore: Store<IQueryState>) {
    this.isCaseTypeDisabled = false;
    this.inputFormErrors = {
      caseType: {},
      title: {}
    };
  }

  ngOnInit () {
    this.inputForm = this.formBuilder.group({
      caseType  : [this.data.input.caseType, Validators.required],
      title  : ['', Validators.required],
      useExistingCaseData: [false],
      selectedCase: [],
      selectedFiledPeriod: [],
      specifyField: []
    });
    this.isCaseTypeDisabled = this.data.input.disableTypeChange;
    this.inputForm.controls['caseType'].valueChanges.pipe( takeUntil(this.unsubscribe$)).subscribe(() => {
      this.onCaseTypeChanged();
    });
    this.inputForm.controls['useExistingCaseData'].valueChanges.pipe( takeUntil(this.unsubscribe$)).subscribe((value) => {
      if(!value){
        this.inputForm.get('selectedCase').setValue('');
      }
    });
    this.inputForm.controls['selectedCase'].valueChanges.pipe( takeUntil(this.unsubscribe$)).subscribe(() => {
      this.onSelectedCaseChanged();
    });
    this.inputForm.controls['specifyField'].valueChanges.pipe( takeUntil(this.unsubscribe$)).subscribe(()  => {
      if (this.inputForm.controls['specifyField'].value === true) {
        this.data.okCaption = 'Next';
      } else {
        this.data.okCaption = 'Done';
      }
    });

    this.inputForm.valueChanges.subscribe(() => {
      this.onFormValuesChanged();
    });
    this.getCases();
  }
  ngAfterViewInit () {
    if (this.elementRef) {
      setTimeout(() => {
        this.elementRef.focus();
      }, 1000);
    }
  }
  private getCases() {
    const queryKey = `DAC6All${this.inputForm.controls['caseType'].value}`;
    QueryProvider.invokeQuery(this.queryStore, queryKey, {});
    this.particleStore.pipe(select(getQueryResponse, queryKey), skip(1)).subscribe(res => {
      if (res.items && res.items.length > 0) {
        const uniqueCaseList = [];
        const map = new Map();
        for (const item of res.items) {
          if (!map.has(item.displayText)) {
            map.set(item.displayText, true);
            uniqueCaseList.push(item);
          }
        }
        this.caseList = res.items;
        this.caseList$.next(uniqueCaseList);
        if (this.inputForm.value['useExistingCaseData']){
          this.inputForm.controls['selectedCase'].setValue(uniqueCaseList[0]);
        }
      } else {
        this.caseList$.next([]);
      }
    });
  }

  onOkClicked() {
    this.data.input['caseType'] = this.inputForm.controls['caseType'].value;
    this.data.input['title'] = this.inputForm.controls['title'].value;
    if (this.inputForm.controls['useExistingCaseData'].value === true) {
      this.data.input['selectedCase'] = this.inputForm.controls['selectedCase'].value.id;
      if (this.inputForm.controls['caseType'].value === 'Arrangement') {
        this.data.input['selectedCase'] = this.inputForm.controls['selectedFiledPeriod'].value.id;
      }
      this.data.input['specifyField'] = this.inputForm.controls['specifyField'].value;
    }
    return true;
  }

  private onCaseTypeChanged() {
    this.getCases();
  }

  onFormValuesChanged() {
    for (const field in this.inputFormErrors) {
      if (!this.inputFormErrors.hasOwnProperty(field)) {
        continue;
      }
      this.inputFormErrors[field] = {};
      const control = this.inputForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.inputFormErrors[field] = control.errors;
      }
    }
    this.data.isDisabledOkButton = !this.inputForm.valid;
  }

  private onSelectedCaseChanged() {
    if (this.inputForm.controls['caseType'].value === 'Arrangement') {
      const filedPeriodList = this.caseList.filter(o => o.displayText === this.inputForm.controls['selectedCase'].value.displayText);
      this.filedPeriodList$.next(filedPeriodList);
      this.inputForm.controls['selectedFiledPeriod'].setValue(filedPeriodList[0]);
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
